export const brandTableKeys = [
  {
    name: "Name",
    key: "name",
  },

  {
    name: "Description",
    key: "description",
  },
];
